import {computed, effect, Injectable, signal} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';


export interface ICalculusState {
  showPercentages: boolean;
  showImportedValues: boolean;
  customPageSize: number;
  hnrConfig: boolean;
}

const INITIAL_STATE: ICalculusState = {
  showPercentages: false,
  showImportedValues: true,
  customPageSize: null,
  hnrConfig: false,
}

const LOCALSTORAGE_KEY = 'calculusState';
const localStorageValue = localStorage.getItem(LOCALSTORAGE_KEY);
const localStorageState: ICalculusState = localStorageValue ? JSON.parse(localStorageValue) : INITIAL_STATE;

@Injectable({
  providedIn: 'root'
})
export class CalculusStore {
  // state
  private state = signal<ICalculusState>(
      localStorageState || INITIAL_STATE
  );

  // selectors
  showPercentages = computed(() => this.state().showPercentages);
  showImportedValues = computed(() => this.state().showImportedValues);
  customPageSize = computed(() => this.state().customPageSize);
  hnrConfig = computed(() => this.state().hnrConfig);
  helpRoute = signal<string>('', {equal: () => false});

  // actions / sources
  showPercentages$ = new Subject<boolean>();
  showImportedValues$ = new Subject<boolean>();
  customPageSize$ = new Subject<number>();
  hnrConfig$ = new Subject<boolean>();
  helpRoute$ = new Subject<string>();

  constructor() {
    effect(() => {
      const state = this.state();
      localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(state));
    });
    // reducers
    this.showPercentages$
      .pipe(takeUntilDestroyed())
      .subscribe(value => {
        this.state.update(state => {
          return {
            ...state,
            showPercentages: value
          }
        });
      });

    this.helpRoute$
      .pipe(takeUntilDestroyed())
      .subscribe((value: string): void => {
        this.helpRoute.set(value);
      });

    this.showImportedValues$
      .pipe(takeUntilDestroyed())
      .subscribe(value => {
        this.state.update(state => {
          return {
            ...state,
            showImportedValues: value
          }
        });
      });

    this.customPageSize$
      .pipe(takeUntilDestroyed())
      .subscribe(value => {
        this.state.update(state => {
          return {
            ...state,
            customPageSize: value
          }
        });
      });

    this.hnrConfig$
    .pipe(takeUntilDestroyed())
    .subscribe(value => {
        this.state.update(state => {
          return {
            ...state,
            hnrConfig: value
          }
      })
    })
  }
}
